// Derives a URL-safe slug from a title, matching the `^[a-z0-9-]+$` convention already
// enforced server-side for page_contents / how-it-works slugs.
export const slugify = (text) =>
  (text || '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
